const columnDepartment = [
  {
    title: "Index",
    scopedSlots: { customRender: "stt" },
    width: 50,
    align: "center",
  },
  {
    title: "Title",
    dataIndex: "name",
    sorter: (departmentA, departmentB) => {
      var codeA = departmentA.name.toUpperCase();
      var codeB = departmentB.name.toUpperCase();
      return codeA.localeCompare(codeB);
    },
    scopedSlots: { customRender: "name" },
  },

  // {
  //   title: "Quản lý",
  //   dataIndex: "managers",
  //   scopedSlots: { customRender: "managers" },
  //   width: 100,
  //   align: "center",
  // },
  {
    title: "Status",
    dataIndex: "status",
    scopedSlots: { customRender: "status" },
    width: 100,
    align: "center",
  },
  {
    title: "Created At",
    dataIndex: "createdAt",
    scopedSlots: { customRender: "createdAt" },
    width: 160,
  },
  {
    title: "Updated At",
    dataIndex: "updatedAt",
    scopedSlots: { customRender: "updatedAt" },
    width: 160,
  },
  {
    title: "",
    dataIndex: "action",
    scopedSlots: { customRender: "action" },
    width: 10,
  },
];

const columnsAllWorkShift = [
  {
    title: "Index",
    key: "stt",
    dataIndex: "stt",
    scopedSlots: { customRender: "stt" },
    width: 50,
    align: "center",
  },
  // {
  //   title: "Mã",
  //   key: "code",
  //   dataIndex: "code",
  //   sorter: (a, b) => a.code.localeCompare(b.code),
  //   fixed: "left",
  // },
  {
    title: "Title",
    key: "title",
    dataIndex: "title",
    sorter: (a, b) => a.title.localeCompare(b.title),
  },
  {
    title: "Start Time",
    dataIndex: "startTime",
    key: "startTime",
    scopedSlots: { customRender: "startTime" },
  },
  {
    title: "End Time",
    dataIndex: "endTime",
    key: "endTime",
    scopedSlots: { customRender: "endTime" },
  },
  {
    title: "Duration",
    dataIndex: "duration",
    key: "duration",
    align: "center",
  },
  // {
  //   title: "Số công",
  //   dataIndex: "coefficient",
  //   key: "coefficient",
  //   align: "center",
  // },
  {
    title: "Overtime",
    key: "isOvertime",
    dataIndex: "isOvertime",
    scopedSlots: { customRender: "isOvertime" },
    align: "center",
  },
];

const columnsManagers = [
  {
    title: "STT",
    key: "stt",
    dataIndex: "stt",
    scopedSlots: { customRender: "stt" },
    width: 50,
    align: "center",
  },
  {
    title: "Fullname",
    key: "fullname",
    dataIndex: "fullname",
    sorter: (a, b) => a.fullname.localeCompare(b.fullname),
  },

  {
    title: "Email",
    key: "email",
    dataIndex: "email",
  },
];

export { columnDepartment, columnsAllWorkShift, columnsManagers };
